import { Component } from '@inter-ikea-core/core';

/**
 * Should be added to entities that are products included in another product (e.g. the 4 included shelves
 * in a pax corner frame). Entities with this component are discregarded when checking if there are
 * invalid products in scene after load.
 */
export default class IncludedProductComponent implements Component {
  static id = 2078;
  typeId = IncludedProductComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
